import { Log, OidcClientSettings, WebStorageStateStore } from 'oidc-client-ts';
import { useEffect, useRef, useState } from 'react';
import { AuthProvider } from 'react-oidc-context';

import { oidcStoragePrefix } from '../constants';

export let storage: WebStorageStateStore | undefined;

type PropsProviderOidc = {
  config: OidcClientSettings;
  debugMode?: boolean;
  children: React.ReactNode;
};

export function ProviderOidc({
  config,
  children,
  debugMode,
}: PropsProviderOidc) {
  const [userStore, setUseStore] = useState<WebStorageStateStore | undefined>(
    undefined
  );
  const stateRef = useRef<{ enableOidcLogger: boolean }>({
    enableOidcLogger: false,
  });
  if (!stateRef.current.enableOidcLogger && debugMode) {
    Log.setLogger(console);
    Log.setLevel(Log.DEBUG);
    stateRef.current.enableOidcLogger = true;
  } else if (stateRef.current && !debugMode) {
    Log.reset();
    stateRef.current.enableOidcLogger = false;
  }

  useEffect(() => {
    storage = new WebStorageStateStore({
      prefix: oidcStoragePrefix,
      store: window.sessionStorage,
    });

    setUseStore(storage);
  }, []);

  if (!userStore) return null;

  return (
    <AuthProvider
      {...config}
      userStore={userStore}
      automaticSilentRenew={false}
      loadUserInfo
    >
      {children}
    </AuthProvider>
  );
}
